import React from "react";

import {Container} from "@pg-design/grid-module";
import {HomeIcon} from "@pg-design/icons-module";
import {rpAppLink} from "@pg-mono/rp-routes";

import {Breadcrumbs} from "../../app/components/breadcrumbs/Breadcrumbs";
import {IBreadcrumb} from "../../app/components/breadcrumbs/IBreadcrumb";

export enum CreditBreadcrumbType {
    OFFERS = 1,
    RATING = 2
}

interface IProps {
    breadcrumbType?: CreditBreadcrumbType;
}

const extraBreadcrumbByType: Record<CreditBreadcrumbType, IBreadcrumb> = {
    [CreditBreadcrumbType.OFFERS]: {name: "kalkulator kredytu", url: rpAppLink.credits.offers()},
    [CreditBreadcrumbType.RATING]: {name: "kalkulator zdolności", url: rpAppLink.credits.rating()}
};

export const CreditBreadcrumbs = (props: IProps) => {
    const items: IBreadcrumb[] = [
        {name: "kredyty", url: rpAppLink.credits.base()},
        ...(props.breadcrumbType != null ? [extraBreadcrumbByType[props.breadcrumbType]] : [])
    ];

    return (
        <Container>
            <Breadcrumbs homePageUrl={rpAppLink.base()} homePageIcon={<HomeIcon size="1.4" />} items={items} />
        </Container>
    );
};
import React from "react";

import {Container} from "@pg-design/grid-module";
import {HomeIcon} from "@pg-design/icons-module";
import {rpAppLink} from "@pg-mono/rp-routes";

import {Breadcrumbs} from "../../app/components/breadcrumbs/Breadcrumbs";
import {IBreadcrumb} from "../../app/components/breadcrumbs/IBreadcrumb";

export enum CreditBreadcrumbType {
    OFFERS = 1,
    RATING = 2
}

interface IProps {
    breadcrumbType?: CreditBreadcrumbType;
}

const extraBreadcrumbByType: Record<CreditBreadcrumbType, IBreadcrumb> = {
    [CreditBreadcrumbType.OFFERS]: {name: "kalkulator kredytu", url: rpAppLink.credits.offers()},
    [CreditBreadcrumbType.RATING]: {name: "kalkulator zdolności", url: rpAppLink.credits.rating()}
};

export const CreditBreadcrumbs = (props: IProps) => {
    const items: IBreadcrumb[] = [
        {name: "kredyty", url: rpAppLink.credits.base()},
        ...(props.breadcrumbType != null ? [extraBreadcrumbByType[props.breadcrumbType]] : [])
    ];

    return (
        <Container>
            <Breadcrumbs homePageUrl={rpAppLink.base()} homePageIcon={<HomeIcon size="1.4" />} items={items} />
        </Container>
    );
};
